<template>
  <transition
    enter-active-class="transition-opacity duration-300"
    leave-active-class="transition-opacity duration-200"
    enter-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div v-if="value" class="absolute h-full z-10 inset-0 overflow-y-auto">
      <div
        class="h-full flex items-center justify-center pt-4 px-4 pb-20 text-center"
      >
        <div class="inset-0 transition-opacity" aria-hidden="true" @click="close">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"
          >&#8203;</span
        >

        <div
          class="dialog-container relative inline-block align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div class="btn-close absolute cursor-pointer" @click="close">
            <svg
              width="24"
              height="24"
              class="w-6 h-6 fill-current text-gray-700"
              viewBox="0 0 24 24"
            >
              <path :d="mdiClose" />
            </svg>
          </div>

          <div class="dialog-card bg-white">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: 'Dialog',
  props: ['value'],
  emits: ['close'],
  data() {
    return {
      mdiClose,
    };
  },
  destroyed() {
    if (this.value) this.close();
  },
  methods: {
    close() {
      this.$emit('close', !this.value);
    },
  },
  watch: {
    value(val) {
      document.body.style.overflow = val ? 'hidden' : 'auto';
    },
  },
};
</script>

<style scoped>
.dialog-container {
  max-width: 480px;
  width: 100%;
  border-radius: 16px;
}

.dialog-card {
  padding: 48px 40px 40px;
}

@media (max-width: 720px) {
  .dialog-card {
    padding: 48px 24px 24px;
  }
}

.btn-close {
  top: 24px;
  right: 24px;
}
</style>
